// diagram layers (in order)

export enum Layer {
  BACKGROUND_LAYER = 'Background',

  MODEL_CONCEPT_RELATIONSHIP_BACKGROUND_LAYER = 'MODEL_CONCEPT_RELATIONSHIP_BACKGROUND',
  MODEL_CONCEPT_RELATIONSHIP_LABEL_BACKGROUND_LAYER = 'MODEL_CONCEPT_RELATIONSHIP_LABEL_BACKGROUND',
  MODEL_CONCEPT_HIERARCHY_BACKGROUND_LAYER = 'MODEL_CONCEPT_HIERARCHY_BACKGROUND',
  MODEL_CONCEPT_HIERARCHY_LABEL_BACKGROUND_LAYER = 'MODEL_CONCEPT_HIERARCHY_LABEL_BACKGROUND',
  MODEL_CONCEPT_CLASS_BACKGROUND_LAYER = 'MODEL_CONCEPT_CLASS_BACKGROUND',
  MAPPING_BACKGROUND_LAYER = 'MAPPING_BACKGROUND',
  MAPPING_LABEL_BACKGROUND_LAYER = 'MAPPING_LABEL_BACKGROUND',
  RESOURCE_BACKGROUND_LAYER = 'RESOURCE_BACKGROUND',

  DEFAULT_LAYER = '',

  MODEL_CONCEPT_RELATIONSHIP_FOREGROUND_LAYER = 'MODEL_CONCEPT_RELATIONSHIP_FOREGROUND',
  MODEL_CONCEPT_RELATIONSHIP_LABEL_FOREGROUND_LAYER = 'MODEL_CONCEPT_RELATIONSHIP_LABEL_FOREGROUND',
  MODEL_CONCEPT_HIERARCHY_FOREGROUND_LAYER = 'MODEL_CONCEPT_HIERARCHY_FOREGROUND',
  MODEL_CONCEPT_HIERARCHY_LABEL_FOREGROUND_LAYER = 'MODEL_CONCEPT_HIERARCHY_LABEL_FOREGROUND',
  MODEL_CONCEPT_CLASS_FOREGROUND_LAYER = 'MODEL_CONCEPT_CLASS_FOREGROUND',
  MAPPING_FOREGROUND_LAYER = 'MAPPING_FOREGROUND',
  MAPPING_LABEL_FOREGROUND_LAYER = 'MAPPING_LABEL_FOREGROUND',
  RESOURCE_FOREGROUND_LAYER = 'RESOURCE_FOREGROUND',

  FOREGROUND_LAYER = 'Foreground',
}

// ordered to insert before the default layer (first inserted is at the bottom)
export const BACKGROUND_LAYERS = [
  Layer.MODEL_CONCEPT_RELATIONSHIP_BACKGROUND_LAYER,
  Layer.MODEL_CONCEPT_RELATIONSHIP_LABEL_BACKGROUND_LAYER,
  Layer.MODEL_CONCEPT_HIERARCHY_BACKGROUND_LAYER,
  Layer.MODEL_CONCEPT_HIERARCHY_LABEL_BACKGROUND_LAYER,
  Layer.MODEL_CONCEPT_CLASS_BACKGROUND_LAYER,
  Layer.MAPPING_BACKGROUND_LAYER,
  Layer.MAPPING_LABEL_BACKGROUND_LAYER,
  Layer.RESOURCE_BACKGROUND_LAYER,
];

// ordered to insert after the default layer (first inserted is at the top)
export const FOREGROUND_LAYERS = [
  Layer.RESOURCE_FOREGROUND_LAYER,
  Layer.MAPPING_LABEL_FOREGROUND_LAYER,
  Layer.MAPPING_FOREGROUND_LAYER,
  Layer.MODEL_CONCEPT_CLASS_FOREGROUND_LAYER,
  Layer.MODEL_CONCEPT_HIERARCHY_LABEL_FOREGROUND_LAYER,
  Layer.MODEL_CONCEPT_HIERARCHY_FOREGROUND_LAYER,
  Layer.MODEL_CONCEPT_RELATIONSHIP_LABEL_FOREGROUND_LAYER,
  Layer.MODEL_CONCEPT_RELATIONSHIP_FOREGROUND_LAYER,
];
